<div class="dashboard-filter-wrapper" [ngClass]="{'dashboard-filter-broker_wr': currentUser?.company?.type == 'BROKER'}">
    <div class="dashboard-filter" [ngClass]="{'dashboard-filter-broker': currentUser?.company?.type == 'BROKER'}">
        <div>
            <app-select
                [label]="filters?.dataRange ? 'Date Range' : 'Select Date Range'"
                [idInfo]="'filter-range'"
                [keyName]="{key:'key', name: 'name'}"
                [value]="$safeNavigationMigration(filters?.dataRange)"
                [list]="rangeTypes"
                [options]="{noFirstOption: true}"
                (onSave)="selectDateRange($event)"
            ></app-select>
        </div>
        <div>
            <app-date
                [label]="'From'"
                [defaultDate]="$safeNavigationMigration(filters?.startDate)"
                [startKey]="'startDate'"
                [parent]="filters"
                [options]="{ timezone: false, fullFormat: true, notDelete: true }"
                (onSave)="setDate('startDate', $event.startDate)"
            ></app-date>
        </div>
        <div>
            <app-date
                [label]="'To'"
                [defaultDate]="$safeNavigationMigration(filters?.endDate)"
                [startKey]="'endDate'"
                [parent]="filters"
                [options]="{ timezone: false, fullFormat: true, notDelete: true }"
                (onSave)="setDate('endDate', $event.endDate)"
            ></app-date>
        </div>
        @if (currentUser?.company?.type !== 'BROKER') {
            <div>
                @if (!filters?.equipmentId) {
                    <app-search
                        [idInfo]="'equipment'"
                        [label]="'Unit'"
                        [resource]="'EQUIPMENT'"
                        [options]="{focus: true}"
                        [method]="'search'"
                        [filter]="{carrierId: $safeNavigationMigration(currentUser?.company?._id), type: 'TRUCK'}"
                        (onChange)="setFilter.emit({equipmentId: $event._id, equipmentName: $event.name})"
                    ></app-search>
                } @else {
                    <app-input
                        [label]="'Unit'"
                        [value]="$safeNavigationMigration(filters?.equipmentName)"
                        [display]="{ remove: true }"
                        [idInfo]="'filter-equipment'"
                        [isReadOnly]="true"
                        (onRemove)="setFilter.emit({equipmentId: null, equipmentName: null})"
                    ></app-input>
                }
            </div>
         }

         @if (currentUser?.company?.type !== 'BROKER') {
            <div>
                @if (!filters?.driverId) {
                    <app-search
                        [label]="'Driver'"
                        [resource]="'CONTACT'"
                        [idInfo]="'filter-driver'"
                        [options]="{focus: true}"
                        [method]="'search'"
                        [filter]="{accountId: $safeNavigationMigration(currentUser?.company._id), type: 'DRIVER', limit: 25, sort: 'quoteCount', dir: 'desc', isAccount: false}"
                        (onChange)="setFilter.emit({driverId: $safeNavigationMigration($event?._id), driverName: $safeNavigationMigration($event?.name)})"
                    ></app-search>
                } @else {
                    <app-input
                        [label]="'Driver'"
                        [value]="$safeNavigationMigration(filters?.driverName)"
                        [display]="{ remove: true }"
                        [idInfo]="'filter-driver'"
                        [isReadOnly]="true"
                        (onRemove)="setFilter.emit({driverId: null, driverName: null})"
                    ></app-input>
                }
            </div>
         }
    </div>
    <button class="reset_btn" (click)="resetFilter()" [disabled]="loading">Reset</button>
</div>
